import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Button } from '@material-ui/core';
import RemoveTextButton from '../atoms/RemoveTextButton';
import listMenuChildTypes from '../../constants/MenuChildType';
import AddGochiKidTextButton from '../atoms/AddGochiKidTextButton';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  leftIcon: {
    padding: '0px 5px'
  },
  textremove: {
    color: '#ccc',
    textAlign: 'center',
    paddingLeft: 12
  },
  menuImage: {
    width: 100,
    height: 63,
    objectFit: 'cover'
  },
  noImage: {
    width: 100,
    height: 63,
    backgroundColor: '#D1D1D1',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    color: '#A5A5A5',
    fontSize: 10
  },
  disabledMenu: {
    opacity: 0.5
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  menus: PropTypes.arrayOf(
    PropTypes.shape({
      menuId: PropTypes.number,
      menuChildType: PropTypes.number,
      shopName: PropTypes.string,
      menuName: PropTypes.string,
      description: PropTypes.string,
      price: PropTypes.number,
      taxType: PropTypes.string,
      image: PropTypes.string,
      updatedAt: PropTypes.string
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const UserTableBody = enhance(
  ({
    menus,
    classes,
    emptyRows,
    page,
    rowsPerPage,
    detailOpenAction,
    removeOpenAction,
    order,
    orderBy,
    isAddGochiKidMenu,
    addOpenAction
  }) => {
    const sortedResult = _.orderBy(menus, orderBy, order);
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(gochiMenu => {
            const key = `${gochiMenu.menuId}-${gochiMenu.shopId}-${
              gochiMenu.groupName
            }`;

            return (
              <TableRow key={key} hover>
                <TableCell
                  className={gochiMenu.showHide ? '' : classes.disabledMenu}
                >
                  {gochiMenu.image ? (
                    <img
                      src={gochiMenu.image}
                      width={100}
                      height={63}
                      className={classes.menuImage}
                      alt="Menu"
                    />
                  ) : (
                    <div className={classes.noImage}>NO IMAGE</div>
                  )}
                </TableCell>
                <TableCell
                  className={gochiMenu.showHide ? '' : classes.disabledMenu}
                >
                  {gochiMenu.shopId}
                </TableCell>
                <TableCell
                  className={gochiMenu.showHide ? '' : classes.disabledMenu}
                >
                  {gochiMenu.shopName}
                </TableCell>
                <TableCell
                  className={gochiMenu.showHide ? '' : classes.disabledMenu}
                >
                  {gochiMenu.menuId}
                </TableCell>
                <TableCell
                  className={gochiMenu.showHide ? '' : classes.disabledMenu}
                >
                  {gochiMenu.menuName}
                </TableCell>
                <TableCell
                  className={gochiMenu.showHide ? '' : classes.disabledMenu}
                >
                  {listMenuChildTypes.map(item => {
                    if (parseInt(gochiMenu.menuChildType, 10) === item.id) {
                      return item.name;
                    }
                    return '';
                  })}
                </TableCell>
                <TableCell>{gochiMenu.excludedTaxPrice}</TableCell>
                <TableCell>{gochiMenu.includedTaxPrice}</TableCell>
                <TableCell>
                  {!isAddGochiKidMenu && (
                    <Button
                      color="primary"
                      onClick={() => detailOpenAction({ id: gochiMenu.menuId })}
                    >
                      詳細
                    </Button>
                  )}
                </TableCell>
                <TableCell>
                  {!isAddGochiKidMenu ? (
                    <RemoveTextButton
                      id={gochiMenu.menuId}
                      onClickAction={removeOpenAction}
                    />
                  ) : (
                    <AddGochiKidTextButton
                      id={gochiMenu.menuId}
                      onClickAction={addOpenAction}
                    />
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && <></>}
      </TableBody>
    );
  }
);

export default withStyles(styles)(UserTableBody);
